























































































































































import Vue from 'vue';
import { mapState } from 'vuex';
import TprForm from '@/components/TprForm.vue';
import FallbackForm from '@/components/FallbackForm.vue';
import SlidersFinance from '@/components/SlidersFinance.vue';
import CarHeadings from '@/components/CarHeadings.vue';
import FinanceDetails from '@/components/FinanceDetails.vue';
import Helpers from '../mixins/helpers';
import faqJson from '@/content/HelpFaqs.json';
import Analytics from '@/mixins/analytics';
import Api from '@/mixins/api';
export default Vue.extend({
	name: 'CheckoutFinance', 
	components: {
		TprForm,
		FallbackForm, 
		SlidersFinance,
		CarHeadings, 
		FinanceDetails
	},
	data(): any {
		return {
			financeSliderTouched: false, 
			isLearnMoreOpen: false,
			openFaq: null,
			data: {
				tprFaqs: []
			}
		};
	},
	computed: {
		...mapState({
			app(): any { return this.$store.state.app },
			finance(): any { return this.$store.state.finance },
			tpr(): any { return this.$store.state.tpr },
			customer(): any { return this.$store.state.customer },
			dealer(): any { return this.$store.state.dealer }
		}), 
		flow(): string {
			return this.$store.getters.flow;
		},
		customerBusinessUse: {
            get(): string {
                return this.customer.businessUse;
            },
            set(v: string){
                this.$store.commit('setCustomer', {
                    businessUse: v
                });
            }
		}
	}, 
	methods: {
		handleFaqClick(faq: any, e: any): void {
			this.$nextTick(() => {
				// todo open / close?
				if (typeof this.openFaq == 'number'){
					Analytics.sendEvent({
						"event": "buttonClick",
						"buttonName": "Toyota Personalised Rate – Learn More - " + faq.q,
					});
				}
			});
		},
		handleLearnMoreClick(): void {
			if (this.isLearnMoreOpen){
				setTimeout(() => {
					this.$emit('collapse');
				},500);
			}
			else {
				Analytics.sendEvent({
					"event": "buttonClick",
					"buttonName": "Toyota Personalised Rate – Learn More - Show Details"
				});
			}
			this.isLearnMoreOpen = !this.isLearnMoreOpen;
		}
	}, 
	mounted(): void {
		Vue.set(this.data, 'tprFaqs', faqJson.faqs.filter(o => o.type == 'Toyota Personalised Repayments'));
	}
});
